<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>菜单管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!--搜索部分-->
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="菜单搜索">
					<el-input v-model="queryKey" placeholder="按菜单名称搜索">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="query">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="create">创建新菜单</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table  border :data="tableData" style="width: 100%">
			<el-table-column type="index" label="序号" width="60px"></el-table-column>
			<el-table-column label="图标" width="60px">
				<template slot-scope="scope">
					<i :class="scope.row.icon"></i>
				</template>
			</el-table-column>
			<table-tree-column prop="name" treeKey="id" label="菜单名称"> </table-tree-column>
			<el-table-column label="路由名称" prop="router" width="250px"></el-table-column>
			<el-table-column label="排序" prop="sort" width="60px"></el-table-column>
			<el-table-column label="操作" width="120">
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-popconfirm title="这是一段内容确定删除吗？" @onConfirm="handleDelete(scope.row)">
						<el-button slot="reference" type="text" size="small">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="sizes, prev, pager, next" :total="0"> </el-pagination>

		<!--创建角色-->
		<el-dialog title="创建菜单" :visible.sync="dialogVisible" width="500px">
			<el-form :model="form" ref="menuForm" :rules="rules">
				<el-form-item label="菜单类型" :label-width="formLabelWidth">
					<el-radio v-model="form.type" :label="0">一级菜单</el-radio>
					<el-radio v-model="form.type" :label="1">子菜单</el-radio>
				</el-form-item>
				<el-form-item label="菜单名称" prop="name" :label-width="formLabelWidth">
					<el-input v-model="form.name" autocomplete="off" placeholder="请输入菜单名称"></el-input>
				</el-form-item>

				<el-form-item label="一级菜单" :label-width="formLabelWidth" v-show="form.type == 1">
					<el-select v-model="form.parent">
						<el-option :label="item.name" :value="item._id.$oid" v-for="(item, index) in parentMenus" :key="index"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="图标(CSS类名称)" :label-width="formLabelWidth" v-show="form.type == 0">
					<el-input v-model="form.icon" autocomplete="off" placeholder="element UI 图标类名称"></el-input>
				</el-form-item>

				<el-form-item label="路由名称" :label-width="formLabelWidth">
					<el-input v-model="form.router" autocomplete="off" placeholder="请输入菜单路径"></el-input>
				</el-form-item>

				<el-form-item label="排序" :label-width="formLabelWidth">
					<el-input-number v-model="form.sort" controls-position="right" :min="1" :max="100"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import userService from '@/service/userService'
	import permissionService from '@/service/permissionService'
	import TableTreeColumn from '@/components/TableTreeColumn'
	export default {
		name: 'MenuIndex',
		components: {
			TableTreeColumn,
		},
		data() {
			return {
				queryKey: '',
				tableData: [],
				parentMenus: [],
				dialogVisible: false,
				formLabelWidth: '120px',
				form: {
					type: 0,
				},
				currentPage: 1,
				pageSize: 10,
				rules: {
					name: [
						{ required: true, message: '请输入菜单名称', trigger: 'blur' },
						{ min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' },
					],
				},
			}
		},
		methods: {
			/**
			 * 创建菜单。
			 */
			create() {
				this.dialogVisible = true
				this.form = {
					type: 0,
					sort: 1,
				}
			},
			/**
			 * 查询菜单。
			 */
			query() {
				permissionService.getUserRights().then(res => {
					var tempArray = []
					res.sort((x, y) => {
						if (x.sort < y.sort) {
							return -1
						} else if (x.sort > y.sort) {
							return 1
						} else {
							return 0
						}
					})

					res.forEach((v, i) => {
						tempArray.push({
							id: v._id.$oid,
							parentId: v.parent,
							name: v.name,
							router: v.router,
							sort: v.sort,
							type: v.type,
							icon: v.icon,
						})
					})

					this.tableData = this.toTree(tempArray)
					this.parentMenus = res.filter(p => p.type == 0)
				})
			},
			/**
			 * 将菜单数据转为树形结构。
			 */
			toTree(data) {
				//转换为数据结构-自己封装吧。
				data.forEach(item => {
					//删除所有children,以防止多次调用
					delete item.children
				})
				var map = {} // 将数据存储为以id为 KEY的 map索引数据列
				data.forEach(item => {
					map[item.id] = item
				})

				var val = []
				data.forEach(item => {
					var parent = map[item.parentId] //以当前遍历项，的parentId,去map对象中找到索引的id
					if (parent) {
						//如果找到索引，说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
						if (!parent.children) {
							parent.children = []
						}
						parent.children.push(item)
					} else {
						val.push(item) //如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
					}
				})
				return val
			},
			/**
			 * 保存菜单。
			 */
			save() {
				this.$refs.menuForm.validate(valid => {
					if (valid) {
						permissionService.saveMenuItem(this.form).then(res => {
							this.dialogVisible = false

							this.query()
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			/**
			 * 删除菜单。
			 */
			handleDelete(row) {
				permissionService.deleteMenu(row.id).then(res => {
					this.query()
				})
			},
			/**
			 * 编辑菜单。
			 */
			handleEdit(row) {
				this.dialogVisible = true
				this.form = {
					_id: {
						$oid: row.id,
					},
					parent: row.parentId,
					name: row.name,
					router: row.router,
					sort: row.sort,
					type: row.type,
					icon: row.icon,
				}
			},
			handleSizeChange() {},
			handleCurrentChange() {},
		},
		created() {
			this.query()
		},
	}
</script>

<style scoped></style>
